import React, {useState, useEffect} from 'react'
import {Button, Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap';

function ConfirmUnsubscribeModal({isOpen, onCancel, onOk, title, children, unsubComplete, unsubWorking}) {
    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>
                {title}
            </ModalHeader>
            <ModalBody>     
                {children}   
            </ModalBody>
            <ModalFooter>
                <Button disabled={unsubComplete || unsubWorking} color="primary" onClick={onOk}>Cancelar suscripción</Button>
                <Button disabled={unsubWorking} color="secondary" onClick={onCancel}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmUnsubscribeModal;